import type { IRequestOptions, IValidatedResponse } from '../../httpClient';
import { getRequest } from '../../httpClient';
import type { IListAllClipsRequest } from './list-all-clips-request';
import type { IListAllClipsResponse } from './list-all-clips-response';
import { listAllClipsResponseSchema } from './list-all-clips-response';

export async function listAllClipsApi(
  params?: IListAllClipsRequest,
  options?: IRequestOptions,
): Promise<IValidatedResponse<IListAllClipsResponse>> {
  const searchParams = new URLSearchParams();
  if (params?.collectionIds?.length) {
    searchParams.set('collectionIds', params.collectionIds.join(','));
  }
  if (params?.cropStatus) {
    searchParams.set('cropStatus', params.cropStatus);
  }
  if (params?.published) {
    searchParams.set('published', params.published);
  }
  if (params?.query) {
    searchParams.set('query', params.query);
  }
  if (params?.cursor) {
    searchParams.set('cursor', params.cursor);
  }
  const qs = searchParams.toString();

  return getRequest<IListAllClipsResponse>({
    path: `/sys/clips${qs ? `?${qs}` : ''}`,
    schema: listAllClipsResponseSchema,
    options,
  });
}
